import React from 'react';


const ChangePasswordInstructions: React.FC = () => {

  return (
    <>
      <h3 style={{ paddingTop: 17 }}>Password Requirements</h3>
      <ul>
        <li>Minimum number of characters: 8</li>
        <li>Minimum numeric characters: 1</li>
        <li>Minimum special characters: 1</li>
        <li>Minimum uppercase characters: 2</li>
        <li>Must be different from your last 4 passwords</li>
      </ul>
    </>
  );
}

export default ChangePasswordInstructions;